import React from 'react';
import { ReactComponent as ArrowUpRight } from 'src/Images/icons/syncEvents/arrow-up-right.svg';
import { ReactComponent as ArrowDownLeft } from 'src/Images/icons/syncEvents/arrow-down-left.svg';

function ToggleSwitch({ value, onChange, themeColor }) {
  return (
    <div className="toggle-container">
      <div
        className={`toggle-option ${value === 'push' ? `active theme-background-${themeColor}` : `text-color-${themeColor}`} text-sm`}
        tabIndex={0}
        role="button"
        onClick={() => onChange('push')}
      >
        {value === 'push' && <ArrowUpRight className="icon-size-lg " />}
        Push
      </div>
      <div
        className={`toggle-option ${value === 'pull' ? `active theme-background-${themeColor}` : `text-color-${themeColor}`} text-sm`}
        tabIndex={0}
        role="button"
        onClick={() => onChange('pull')}
      >
        {value === 'pull' && <ArrowDownLeft className="icon-size-lg " />}
        Pull
      </div>
    </div>
  );
}

export default ToggleSwitch;
